export default __webpack_public_path__ + "static/media/cern-semibold.e04b8df2.woff2";